import { render, staticRenderFns } from "./NewSampleBatchDialog.vue?vue&type=template&id=470130ec&scoped=true"
import script from "./NewSampleBatchDialog.vue?vue&type=script&lang=ts"
export * from "./NewSampleBatchDialog.vue?vue&type=script&lang=ts"
import style0 from "./NewSampleBatchDialog.vue?vue&type=style&index=0&id=470130ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470130ec",
  null
  
)

export default component.exports